import { render } from "./GimCustomAdmin.vue?vue&type=template&id=16a0b42d"
import script from "./GimCustomAdmin.vue?vue&type=script&lang=js"
export * from "./GimCustomAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__